import ProfileService from '../services/profile.service';

export default {
  namespaced: true,
  state: {
    profile: null,
    stockCurrency: null,
  },
  mutations: {
    profile(state, profile) {
      state.profile = profile;
    },
    stockCurrency(state, stockCurrency) {
      state.stockCurrency = stockCurrency;
    },
    profileProp(state, payload) {
      const profile = { ...state.profile };
      profile[payload.field] = payload.newVal;
      state.profile = profile;
    },
  },
  actions: {
    init({ dispatch }) {
      dispatch('getProfile');
    },
    getProfile({ commit }) {
      ProfileService.getProfile()
        .then((profile) => commit('profile', profile));
    },
    updateProfile({ state }) {
      return ProfileService.updateProfile(state.profile);
    },
  },
};
